export const baseApiUrl = 'https://drive.wps.com'
// export const baseApiUrl = 'https://proxy.wps.com:3001'
export const accountApiUrl = 'https://account.wps.com'
export const pageCount = 20
export const ExtMapping = {
  'img': ['jpg', 'jpeg', 'png', 'gif', 'bmp'],
  'zip': ['zip', '7z', 'rar', 'iso'],
  'doc': ["doc", "dot", "wps", "wpt", "docx", "dotx", "docm", "dotm","uof","xml"],
  'xls': ["xls", "xlt", "et", "xlsx", "xltx", "csv", "xlsm", "xltm"],
  'ppt': ["ppt", "pptx", "pptm", "ppsx", "ppsm", "pps", "potx", "potm", "dpt", "dps"],
  'txt': ['txt', 'text'],
  'pdf': ['pdf'],
  'pom': ['pom'],
  'pof': ['pof']
}
export const folderRoute = '/mine'
export const previewRoute = '/view'
export const editable = [
  "doc", "dot", "wps", "wpt", "docx", "dotx", "docm", "dotm",
  "xls", "xlt", "et", "xlsx", "xltx", "csv", "xlsm", "xltm",
  "ppt", "pptx", "pptm", "ppsx", "ppsm", "pps", "potx", "potm", "dpt", "dps",
  "rtf", "txt", "xml", "mhtml", "mht", "html", "htm", "uof"
]
export const canroam = [
  "doc", "dot", "wps", "wpt", "docx", "dotx", "docm", "dotm",
  "xls", "xlt", "et", "xlsx", "xltx", "csv", "xlsm", "xltm",
  "ppt", "pptx", "pptm", "ppsx", "ppsm", "pps", "potx", "potm", "dpt", "dps"
]
export const feedback = 'https://feedback.wps.com'
export const shareDomin = 'https://s.docworkspace.com'
var commonFile = [{
    key: 'Share'
  }, {
    key: 'Star',
    divided: true
  },{
    key: 'Copy',
    divided: true
  },{
    key: 'Move'
  },{
    key: 'Rename'
  },{
    key: 'History'
  },{
    key: 'Download',
    divided: true
  }
]
export const menus = {
  sharedFile: [
  ...commonFile,
  {
    key: 'Stopshare',
    divided: true,
    danger: true
  }
],
cloudFile: [
  ...commonFile,
{
  key: 'Delete',
  divided: true,
  danger: true
}],
cloudFolder: [{
    key: 'Star'
  }, {
    key: 'Copy',
    divided: true
  }, {
    key: 'Move'
  }, {
    key: 'Rename'
  }, {
    key: 'Delete',
    divided: true,
    danger: true
  }
],
messenger: [
  {
    key: 'Star'
  }, {
    key: 'Copy',
    divided: true
  }, {
    key: 'Delete',
    divided: true,
    danger: true
  }
],
  trash: [
    {
      key: 'Recover'
    }, {
      key: 'Deletefoever',
      divided: true,
      danger: true
    }
  ],
  trashFolder: [{
    key: 'Deletefoever',
      danger: true
  }],
  shareFile: [
    {
      key: 'Share'
    }, {
      key: 'Star',
      divided: true
    }, {
      key: 'Download',
      divided: true
    }, {
      key: 'Delete',
      divided: true,
      danger: true
    }
  ],
  starShare: [
    {
      key: 'Share'
    }, {
      key: 'Star',
      divided: true
    }, {
      key: 'Download',
      divided: true
    }
  ],
  latest: [],
  team: [
    {
      key: 'Rename'
    }
  ]
}


// WEBPACK FOOTER //
// ./src/config/index.js